import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => {
    const { t } = useTranslation();

    return (
        <Form className="mb-3">
            <Row className="align-items-center">
                <Col xs="auto">
                    <Form.Label className="mb-0 me-2">{t('dateRange.from')}:</Form.Label>
                </Col>
                <Col xs="auto">
                    <Form.Control
                        type="date"
                        value={startDate}
                        onChange={(e) => onStartDateChange(e.target.value)}
                        className="me-3"
                    />
                </Col>
                <Col xs="auto">
                    <Form.Label className="mb-0 me-2">{t('dateRange.to')}:</Form.Label>
                </Col>
                <Col xs="auto">
                    <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default DateRangePicker;
